import { resolveDashboardView } from "../lib/dashboard";

const DASHBOARD_TITLES: Record<string, string> = {
  overview: "Home",
  passport: "Buyer Passport",
  readiness: "Readiness",
  properties: "Saved Homes",
  documents: "Documents",
  "rate-watch": "Rate Watch",
  feed: "Home",
  advisor: "Advisor",
};

const STATIC_TITLES: Record<string, string> = {
  "/": "Get Started",
  "/onboarding": "Get Started",
  "/assessment": "Get Started",
  "/readiness": "Readiness",
  "/login": "Sign in",
  "/pros/join": "Join",
  "/pros/welcome": "Welcome",
  "/dashboard": "Home",
  "/dashboard/settings": "Settings",
  "/dashboard/automation": "Automation",
  "/dashboard/automation/rate-alerts": "Automation",
  "/dashboard/rate-alerts": "Automation",
  "/dashboard/passport": "Buyer Passport",
  "/dashboard/publish": "Buyer Passport",
  "/offers": "Your Offers",
  "/marketplace": "Browse Agents",
  "/marketplace/browse": "Browse Agents",
  "/threads": "Messages",
  "/feed": "Notifications",
  "/team": "Your Team",
  "/calculators": "Calculators",
  "/calculators/true-cost": "True Cost Calculator",
  "/help": "Help Center",
  "/preview/dashboard": "Home",
  "/preview/settings": "Settings",
  "/preview/offers": "Your Offers",
  "/preview/marketplace/browse": "Browse Agents",
  "/preview/threads": "Messages",
  "/preview/feed": "Notifications",
  "/preview/team": "Your Team",
};

/** Resolves a generic, privacy-safe title from the current consumer route. */
export function getConsumerDocumentTitle(
  pathname: string,
  search = "",
): string {
  const path = normalizePath(pathname);
  if (path === "/dashboard") {
    const view = resolveDashboardView(new URLSearchParams(search));
    return titleFor(DASHBOARD_TITLES[view] ?? "Home");
  }

  const staticTitle = STATIC_TITLES[path];
  if (staticTitle) return titleFor(staticTitle);

  if (/^\/login(?:\/|$)/.test(path)) return titleFor("Sign in");
  if (/^\/invite\/[^/]+\/?$/.test(path)) return titleFor("Join");
  if (/^\/offers\/[^/]+\/?$/.test(path)) return titleFor("Offer Details");
  if (/^\/market\/agents\/[^/]+\/offers\/[^/]+\/?$/.test(path)) {
    return titleFor("Offer Details");
  }
  if (/^\/market\/agents\/[^/]+\/?$/.test(path)) {
    return titleFor("Agent Profile");
  }
  if (/^\/marketplace\/claims\/[^/]+\/?$/.test(path)) {
    return titleFor("Your Offer");
  }
  if (/^\/threads\/[^/]+\/profile\/?$/.test(path)) {
    return titleFor("Contact Profile");
  }
  if (/^\/threads\/[^/]+\/?$/.test(path)) return titleFor("Conversation");
  if (/^\/team\/[^/]+\/?$/.test(path)) return titleFor("Team Member");
  if (/^\/properties\/[^/]+\/?$/.test(path)) return titleFor("Home Details");
  if (/^\/calculators\/[^/]+\/?$/.test(path)) return titleFor("Calculator");
  if (/^\/pros\/welcome\/?$/.test(path)) return titleFor("Welcome");
  if (/^\/admin(?:\/|$)/.test(path)) return titleFor("Admin");
  if (/^\/preview\//.test(path) || /^\/__/.test(path)) {
    return titleFor("Preview");
  }

  // Unknown and redirect-only routes keep the product title until the router
  // completes its redirect. This avoids displaying a route's private slug.
  return "Sill";
}

function normalizePath(pathname: string): string {
  if (!pathname || pathname === "/") return "/";
  return pathname.replace(/\/+$/, "");
}

function titleFor(screenName: string): string {
  return `${screenName} - Sill`;
}
